export default __webpack_public_path__ + "static/media/nigel1.7e1fb117.JPEG";